import { INotifications, IProjectNotificationsMention } from '@app/@introspection';
import { NotificationsService } from '@core/services/notifications/notifications.service';
import {
  InviteNotificationTemplate,
  isMachineStartedNotification,
  isMachineStoppedNotification,
  isProjectInviteNotification,
  isProjectMentionNotification,
  isProjectRemoveNotification,
} from '@core/services/notifications/templates';
import { Inject } from '@rxdi/core';
import { Component, css, html, LitElement } from '@rxdi/lit-html';
import { Router } from '@rxdi/router';
import { ResponsiveService } from '@rxdi/ui-components/services';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { notification } from '../icons/notification';

const style = css`
  .notifications {
    color: white;
    font-weight: 500;
    font-size: 11px;
    padding: 1px 5px 1px 5px;
    border-radius: 5px;
    background: red;
    position: absolute;
    left: 15px;
    top: -5px;
  }
`;

/**
 * @customElement notifications-feed
 */
@Component({
  selector: 'notifications-feed',
  template(this: NotificationIconComponent) {
    return html`
      <rx-monad>
        <rx-state
          .value=${combineLatest([this.notificationService.subscribeToNotifications(), this.responsive.width]).pipe(
            map(([user, width]) => [user, width < 600])
          )}
        ></rx-state>
        <rx-style .value=${style}></rx-style>
        <rx-render
          .state=${([notifications, mobile]: [INotifications[], boolean]) => html`
            <dropdown-component
              .border=${true}
              .left=${!!notifications.length}
              .marginLeft=${mobile ? '0px' : '-380px'}
              .menuItems=${[
                ...notifications
                  .map((n) => {
                    if (isProjectInviteNotification(n)) {
                      return InviteNotificationTemplate(n)([this.notificationService, this.router]);
                    }
                    if (isProjectRemoveNotification(n)) {
                      return {
                        read: n.read,
                        html: html`
                          <div style="width: 355px">
                            <project-remove-template-notifications
                              @click=${() => {
                                if (!n.read) {
                                  this.notificationService.readNotification(n.id).subscribe();
                                }
                              }}
                              .notification=${n}
                            ></project-remove-template-notifications>
                          </div>
                        `,
                      };
                    }

                    if (isProjectMentionNotification(n)) {
                      return {
                        read: n.read,
                        html: html`
                          <div style="width: 355px">
                            <project-card-mention-template
                              @click=${() => {
                                if (!n.read) {
                                  this.notificationService.readNotification(n.id).subscribe();
                                }
                                const message = n.data.message as IProjectNotificationsMention;
                                this.router.go(`/cards/${message.comment.card.id}`);
                              }}
                              .notification=${n}
                            ></project-card-mention-template>
                          </div>
                        `,
                      };
                    }
                    if (isMachineStartedNotification(n)) {
                      return {
                        read: n.read,
                        html: html`
                          <div style="width: 355px">
                            <machine-started-template-notifications
                              @click=${() => {
                                if (!n.read) {
                                  this.notificationService.readNotification(n.id).subscribe();
                                }
                              }}
                              .notification=${n}
                            ></machine-started-template-notifications>
                          </div>
                        `,
                      };
                    }
                    if (isMachineStoppedNotification(n)) {
                      return {
                        read: n.read,
                        html: html`
                          <div style="width: 355px">
                            <machine-stopped-template-notifications
                              @click=${() => {
                                if (!n.read) {
                                  this.notificationService.readNotification(n.id).subscribe();
                                }
                              }}
                              .notification=${n}
                            ></machine-stopped-template-notifications>
                          </div>
                        `,
                      };
                    }
                    return html` Unknown template `;
                  })
                  .reverse()
                  .slice(0, 7),
                html`
                  <div
                    @click=${() => this.router.go('/profile/settings/notifications')}
                    style="text-align: center; font-size: 12px;"
                  >
                    view more
                  </div>
                `,
              ]}
            >
              <div style="margin-right: 10px;margin-top: 3px;">
                ${notification}
                <r-if .exp=${notifications.length > 0}>
                  <span class="notifications">${notifications.filter((n) => !n.read).length}</span>
                </r-if>
              </div>
            </dropdown-component>
          `}
        ></rx-render>
      </rx-monad>
    `;
  },
})
export class NotificationIconComponent extends LitElement {
  @Router()
  private router: Router;

  @Inject(NotificationsService)
  private notificationService: NotificationsService;

  @Inject(ResponsiveService)
  private responsive: ResponsiveService;
}
